// ModalLabel.jsx

import React from 'react';

// CSS
import './ModalLabel.css';

/**
 * ModalLabel
 * 
 * A simple label component for modals.
 *  
 *
 * @param {string} label - The text to display inside the label.
 * 
 * @returns {ReactNode} - ModalLabel.
 */
const ModalLabel = React.memo(({ label }) => {

    // ----- RENDER ----- //

    return (

        <div
          className="modal-label-container"
        >
            {label}
        </div>
    );

});

// Dev Tools
ModalLabel.displayName = 'ModalLabel';

export default ModalLabel;
